import { LakeUser } from '@api/core';
import { EnumTranslation, getInvalidEnumTranslation, getSortedTranslations } from '@shared/enums/shared/enums.utils';
import { assertNever } from '@shared/utils/assertions';

export namespace UserRollEnum {
  const values: readonly LakeUser.RoleEnum[] = Object.values(LakeUser.RoleEnum);

  export function translate(val: LakeUser.RoleEnum): string {
    return toEnumTranslation(val).description;
  }

  export const ADMIN_ROLES: LakeUser.RoleEnum[] = [
    LakeUser.RoleEnum.Admin,
    LakeUser.RoleEnum.SuperAdmin,
    LakeUser.RoleEnum.AdminRead,
    LakeUser.RoleEnum.AdminCompliance,
  ];

  export function getTranslatedOrderedValues(toTranslateAndOrder?: readonly LakeUser.RoleEnum[]) {
    return getSortedTranslations(toTranslateAndOrder || values, toEnumTranslation);
  }

  export function toEnumTranslation(val: LakeUser.RoleEnum): EnumTranslation {
    switch (val) {
      case 'ADMIN':
        return {
          description: 'Admin',
          order: 0,
        };
      case 'CLIENT':
        return {
          description: 'Client',
          order: 1,
        };
      case 'CLIENT_API_KEY':
        return {
          description: 'Client API Key',
          order: 2,
        };
      case 'ADMIN_READ':
        return {
          description: 'Admin Read',
          order: 3,
        };
      case 'SUPER_ADMIN':
        return {
          description: 'Super Admin',
          order: 4,
        };
      case 'ADMIN_COMPLIANCE':
        return {
          description: 'Admin Compliance',
          order: 5,
        };
      default:
        return assertNever<EnumTranslation>(val, getInvalidEnumTranslation(val));
    }
  }
}
